<div class="container-fluid">
  <!-- Page Header with Utility Buttons -->
  <div class="d-flex flex-column flex-lg-row justify-content-lg-between align-items-start align-items-lg-baseline mb-3">
    <h1 class="page-header mb-2 mb-lg-0">Inquiry Data Report</h1>

    <!-- Utility Buttons -->
    <div class="d-flex flex-column flex-md-row align-items-start align-items-md-center" style="margin-top: 0.5rem;">
      <!-- Button Group -->
      <div class="d-flex flex-wrap gap-1">
        <button
          style="color:#000; background-color: #82CFFD !important; border-color: #82CFFD !important;"
          mat-flat-button
          class="me-1 mb-1"
          (click)="refreshData()">
          Refresh
        </button>
        <button
          style="color:#fff; background-color: #0AC92B !important; border-color: #0AC92B !important;"
          mat-flat-button
          class="me-1 mb-1"
          [disabled]="isLoading"
          (click)="downloadInquiryReport()">
          <mat-icon *ngIf="isLoading" class="mat-icon-animate-spin">autorenew</mat-icon>
          <ng-container *ngIf="!isLoading">
            <mat-icon>file_download</mat-icon>
            <span>Export</span>
          </ng-container>
          <span *ngIf="isLoading">Exporting...</span>
        </button>
        <button style="background-color: transparent !important; border: none;"
          (click)="printInquiryReport()"
          [disabled]="isLoading"
          type="button"
          mat-icon-button
          class="me-1 mb-1"
          matTooltip="Print inquiry report"
          matTooltipPosition="below"
          aria-label="Print inquiry report">
          <mat-icon style="color: #1C3F8B;">print</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        Filter
      </mat-panel-title>
      <mat-panel-description>
        <app-filter-results-panel [parameters]=queryParams></app-filter-results-panel>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <form (ngSubmit)="onSubmit(f)" #f=ngForm class="form">
      <div class="row">

        <!-- Autocomplete Name (First + Last combined) -->
        <div class="col-12 col-sm-6 col-lg">
          <mat-form-field class="full-width-field">
            <mat-label>Name</mat-label>
            <input name="contact_id" autocomplete="off" (input)="onNameInput($event)" matInput ngModel
              [matAutocomplete]="autoCompleteViewName">
            <button type="button" matSuffix mat-icon-button aria-label="manage_accounts">
              <mat-icon>manage_accounts</mat-icon>
            </button>
          </mat-form-field>
          <mat-autocomplete #autoCompleteViewName="matAutocomplete" [displayWith]="displayName" (optionSelected)="onSubmit(f)">
            <mat-option *ngFor="let option of autoCompleteNameOptions" [value]="option.value">
              {{option.label}}
            </mat-option>
          </mat-autocomplete>
        </div>

        <div class="col-12 col-sm-6 col-lg">
          <mat-form-field class="full-width-field">
            <mat-label>Inquired Date Range</mat-label>
            <mat-date-range-input [rangePicker]="inquiredPicker">
              <input name="field_inquired_start" ngModel matStartDate placeholder="Start date">
              <input name="field_inquired_end" (dateChange)="onSubmit(f)" ngModel matEndDate placeholder="End date">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="inquiredPicker"></mat-datepicker-toggle>
            <mat-date-range-picker #inquiredPicker></mat-date-range-picker>
          </mat-form-field>
        </div>

        <div class="col-12 col-sm-6 col-lg">
          <mat-form-field class="full-width-field">
            <mat-label>Email</mat-label>
            <input name="field_email_value" (input)="onViewsAutocompleteEmail($event)" matInput ngModel
              [matAutocomplete]="autoCompleteViewEmail">
            <button type="button" matSuffix mat-icon-button aria-label="manage_accounts">
              <mat-icon>manage_accounts</mat-icon>
            </button>
          </mat-form-field>
          <mat-autocomplete #autoCompleteViewEmail="matAutocomplete" (optionSelected)="onSubmit(f)">
            <mat-option *ngFor="let option of autoCompleteOptions" [value]="option.label">
              {{option.value}} ({{option.label}})
            </mat-option>
          </mat-autocomplete>
        </div>

        <!-- Autocomplete First and Last Name -->
        <div class="col-12 col-sm-6 col-lg">
          <mat-form-field class="full-width-field">
            <mat-label>Inquiry Taker</mat-label>
            <input name="inquiry_taker" (input)="onFirstLastNameInput($event)" matInput ngModel
              [matAutocomplete]="autoCompleteViewFirstLastName">
            <button type="button" matSuffix mat-icon-button aria-label="manage_accounts">
              <mat-icon>manage_accounts</mat-icon>
            </button>
          </mat-form-field>
          <mat-autocomplete #autoCompleteViewFirstLastName="matAutocomplete" [displayWith]="displayInquiryTaker" (optionSelected)="onSubmit(f)">
            <mat-option *ngFor="let option of autoCompleteFirstLastNameOptions" [value]="option.value">
              {{option.label}}
            </mat-option>
          </mat-autocomplete>
        </div>

        <div class="col-12 col-sm-6 col-lg">
          <mat-form-field class="full-width-field">
            <mat-label>Teacher</mat-label>
            <input name="teacher" (input)="onAutocompleteInstructor($event)" matInput ngModel
              [matAutocomplete]="autoCompleteInstructor">
            <button type="button" matSuffix mat-icon-button aria-label="manage_accounts">
              <mat-icon>manage_accounts</mat-icon>
            </button>
          </mat-form-field>
          <mat-autocomplete #autoCompleteInstructor="matAutocomplete" [displayWith]="displayTeacher" (optionSelected)="onSubmit(f)">
            <mat-option *ngFor="let option of autocompleteInstructorOptions" [value]="option.value">
              {{option.label}}
            </mat-option>
          </mat-autocomplete>
        </div>

        <div class="col-12 col-sm-6 col-lg">
          <mat-form-field class="full-width-field">
            <mat-label>Inquiry Method</mat-label>
            <mat-select name="field_inquiry_method" ngModel (selectionChange)="onSubmit(f)">
              <mat-option [value]="''">All</mat-option>
              <mat-option *ngFor="let element of this._fieldsService.field_inquiry_method" [value]="element.key">
                {{ element.value }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <section class="section">

          <div class="float-end bring-inline">
            <button type="button" (click)="resetForm()" color="primary" mat-flat-button class="me-1" mat-button>Clear</button>
          </div>

        </section>


      </div>

    </form>

  </mat-expansion-panel>

  <mat-progress-bar [class.invisible]="!ShowProgressBar" mode="indeterminate"></mat-progress-bar>

  <!-- <mat-form-field appearance="standard">
    <mat-label>Filter</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="" #input>
  </mat-form-field> -->

  <!-- <div class="example-container mat-elevation-z8">
  <div class="loading-shade"
    *ngIf="ShowProgressBar">
    <mat-spinner *ngIf="ShowProgressBar"></mat-spinner>
    <div class="example-rate-limit-reached" *ngIf="isRateLimitReached">
      No limit
    </div>
  </div>
  </div> -->

  <div class="table-responsive-sticky table-responsive">

    <table mat-table #displayTable [dataSource]="dataSource" matSort (matSortChange)="sortDataView($event)" class="mt-4">

      <!-- field_first_name Column -->
      <ng-container matColumnDef="field_first_name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by First Name">
          First Name
        </th>
        <td mat-cell *matCellDef="let element">
          {{element.field_first_name}}
          <div class="small text-muted" *ngFor="let c of secondaryContacts(element)">{{c.first_name}}</div>
        </td>
      </ng-container>

      <!-- field_last_name Column -->
      <ng-container matColumnDef="field_last_name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Last Name">
          Last Name
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.field_last_name }}
          <div class="small text-muted" *ngFor="let c of secondaryContacts(element)">{{c.last_name}}</div>
        </td>
      </ng-container>

      <!-- field_inquired Column -->
      <ng-container matColumnDef="field_inquired">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Inquired">
          Inquired
        </th>
        <td mat-cell *matCellDef="let element"> {{ reportDateService.formatDate(element.field_inquired) }}
        </td>
      </ng-container>

      <!-- field_booked_on Column -->
      <ng-container matColumnDef="field_booked_on">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Booked On">
          Booked On
        </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.field_booked_on; else bookButton">
            {{ reportDateService.formatDate(element.field_booked_on) }}
          </ng-container>
          <ng-template #bookButton>
            <button mat-raised-button color="primary" (click)="openBookDialog(element)">
              Book Student
            </button>
          </ng-template>
        </td>
      </ng-container>

      <!-- field_showed Column -->
      <ng-container matColumnDef="field_showed">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Showed">
          Showed
        </th>
        <td mat-cell *matCellDef="let element"> {{ reportDateService.formatDate(element.field_showed) }} </td>
      </ng-container>

      <!-- inquiry_taker Column -->
      <ng-container matColumnDef="inquiry_taker">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Inquiry Taker">
          Inquiry Taker
        </th>
        <td mat-cell *matCellDef="let element"> {{ element.inquiry_taker }} </td>
      </ng-container>

      <!-- teacher Column -->
      <ng-container matColumnDef="teacher">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Teacher">
          Teacher
        </th>
        <td mat-cell *matCellDef="let element"> {{ element.teacher }} </td>
      </ng-container>

      <!-- field_email Column -->
      <ng-container matColumnDef="field_email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Email">
          Email
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.field_email }}
          <ng-container *ngFor="let c of secondaryContacts(element)">
            <div class="small text-muted" *ngIf="c.email">{{c.email}}</div>
          </ng-container>
        </td>
      </ng-container>

      <!-- field_cell_phone Column -->
      <ng-container matColumnDef="field_cell_phone">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Cell Phone">
          Cell Phone
        </th>
        <td mat-cell *matCellDef="let element">
          {{element.field_cell_phone}}
          <ng-container *ngFor="let c of secondaryContacts(element)">
            <div class="small text-muted" *ngIf="c.phone">{{c.phone}}</div>
          </ng-container>
        </td>
      </ng-container>

      <!-- field_inquiry_method Column -->
      <ng-container matColumnDef="field_inquiry_method">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Inquiry Method">
          Inquiry Method
        </th>
        <td mat-cell *matCellDef="let element"> {{ element.field_inquiry_method }}
        </td>
      </ng-container>

      <!-- field_notes Column -->
      <ng-container matColumnDef="field_notes">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Notes">
          Notes
        </th>
        <td mat-cell *matCellDef="let element"> {{ element.field_notes }} </td>
      </ng-container>

      <!-- actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>
          Actions
        </th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button [matMenuTriggerFor]="inquiryMenu" [matMenuTriggerData]="{element: element}">
            <mat-icon>more_vert</mat-icon>
          </button>
        </td>
      </ng-container>

      <!-- Footer for pagination -->
      <ng-container matColumnDef="pagination-footer">
        <td mat-footer-cell *matFooterCellDef [attr.colspan]="displayedColumns.length">
          <mat-paginator (page)="pageChanged($event)" [pageSizeOptions]="onPageSizeOptions()" [length]="30"
            [disabled]="ShowProgressBar"
            [pageSize]="paginationTotalPages" [pageIndex]="paginationIndex" aria-label="Select page of view"></mat-paginator>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row matRipple *matRowDef="let row; columns: displayedColumns;"></tr>
      <tr mat-footer-row *matFooterRowDef="['pagination-footer']; sticky: true"></tr>
    </table>

    <mat-menu #inquiryMenu="matMenu">
      <ng-template matMenuContent let-element="element">
        <button mat-menu-item
          (click)="openEntityComponent(StudentInquiryDetailsComponent, 'student_accounts', 'student_account', 'edit', element.student_account_id)">
          <mat-icon>edit</mat-icon>
          <span>Edit Inquiry Information</span>
        </button>
        <button mat-menu-item
          (click)="openDialog(StudentDashboardWrapperComponent, 'largerScreenDashboard', { student_id: element.contact_id })">
          <mat-icon>person</mat-icon>
          <span>Student Dashboard</span>
        </button>
        <button mat-menu-item *ngIf="!element.field_booked_on"
          (click)="openBookDialog(element)">
          <mat-icon>event_available</mat-icon>
          <span>Book Student</span>
        </button>
      </ng-template>
    </mat-menu>

  </div>
</div>
